module.exports = __webpack_public_path__ + "static/media/rust.f30849f8.gif";